import React, {useMemo} from 'react';
import {randomString} from '../../../tools/func';

interface CheckedEvent {
    target:{
        checked:boolean
    }
}

export default function Checkbox({checked, value, label, onChange, small, disabled}: {
    checked:boolean,
    value?: string;
    label?: string;
    onChange?:(inp: CheckedEvent)=>void,
    small?: boolean
    disabled?: boolean
}) {
    const id = useMemo(()=>{
       return randomString()
    },[])
    const isHTMLLabel = String(label).includes("<")
    const cls = `mb-0 ${small ? 'text-sm' : ''}`
    return (<div className={'form-group d-flex align-items-center'}>
        <input disabled={disabled} className="form-check-input" onChange={onChange} type="checkbox" id={id}
               value={value}
               checked={checked || false}
        />
        {
            isHTMLLabel ? <label className={cls} htmlFor={id} dangerouslySetInnerHTML={{__html: String(label)}}/> :
            <label className={`mb-0 ${small ? 'text-sm' : ''}`}
                   htmlFor={id}>{label}</label>
        }
    </div>);
}
